function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "logotipos"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "120.78 44.09 96.63 2.25 72.47 44.09 48.31 85.93 24.16 127.77 72.47 127.77 96.63 85.93 120.78 127.77 169.1 127.77 144.94 85.93 120.78 44.09"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.31 169.61 24.16 127.77 0 169.61 48.31 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "96.63 169.61 120.78 127.77 72.47 127.77 96.63 169.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "193.25 169.61 169.1 127.77 144.94 169.61 193.25 169.61"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M896.07,2.12H933L857.73,169.61H828.32L753,2.12h38.11l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M946.18,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1038.51,166.67q-17.54-5.05-29-14.23l11.76-26.35A92.28,92.28,0,0,0,1075.33,143q16,0,24.58-5.06t8.58-14.23q0-8-7.88-12.59T1073,102.33q-22.11-4.45-35.17-10.94t-19-15.76q-6-9.28-6-23.17a46.2,46.2,0,0,1,8.35-27q8.36-12,23.41-18.7T1079.33,0a113.9,113.9,0,0,1,34.34,5.18q16.47,5.18,26.35,14.11l-11.76,26.35q-22.12-16.93-48.7-16.94-14.11,0-22.58,5.65t-8.47,15.29a14.13,14.13,0,0,0,3.17,9.41q3.18,3.77,10.71,6.7t21.4,5.76q32.24,7.06,46.47,18.35t14.23,30.82q0,23.53-18.35,37.29t-51.05,13.76A131.33,131.33,0,0,1,1038.51,166.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1171.07,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1274.93,161.26a70.56,70.56,0,0,1-28.46-30q-10-19.53-10-45.64t10-45.4a70.9,70.9,0,0,1,28.46-29.76Q1293.4,0,1318.33,0t43.29,10.47a70.44,70.44,0,0,1,28.23,29.76q9.89,19.29,9.88,45.4t-9.88,45.64a70.11,70.11,0,0,1-28.23,30q-18.34,10.47-43.29,10.47T1274.93,161.26Zm76.46-33q11.86-14.82,11.88-42.58t-11.88-42.34q-11.88-14.59-33.06-14.59t-33,14.59q-11.88,14.58-11.88,42.34,0,28,11.88,42.7t33,14.7Q1339.51,143,1351.39,128.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1535,2.12h34.59V169.61h-27.29l-83.51-106.8v106.8h-34.35V2.12h27L1535,108.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M210,169.61V2.12h36.69V139.74h74.81v29.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M343.81,169.61V2.12h36.7V169.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M536.94,2.12h36.94L498.6,169.61H469.19L393.91,2.12H432l52.23,121.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M587.05,169.61V2.12h115.5V30.58H622.81V70.11h74.8V98.8h-74.8v42.35h79.74v28.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1203.93,308.62v-85.8h57.36V235h-42.17v23.86h39.76v12.29h-39.76v25.31h42.17v12.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1292.38,308.62l-26.27-60.74h15.79l19.16,47.6h-3.38l19.52-47.6h15l-26.64,60.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1391.19,301.87a30.86,30.86,0,0,1-10.66,5.6,42.48,42.48,0,0,1-12.84,2,36.47,36.47,0,0,1-17-3.74,25.85,25.85,0,0,1-11-10.84,34.77,34.77,0,0,1-3.86-16.87,35.35,35.35,0,0,1,3.74-16.57,28,28,0,0,1,10.36-11.21,28.84,28.84,0,0,1,15.3-4,27.21,27.21,0,0,1,14.46,3.67,24.43,24.43,0,0,1,9.34,10.55,37,37,0,0,1,3.32,16.26V279H1349l.12-8.07h34.22l-4.1,4.1q.12-8.81-3.43-13.38T1365.52,257q-7.23,0-11.2,5.12t-4,14.64q0,10.84,4.46,16t13.5,5.12a29.7,29.7,0,0,0,9.7-1.63,30.86,30.86,0,0,0,8.85-4.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1404.93,308.62V265q0-4.33-.18-8.67c-.12-2.89-.39-5.74-.79-8.56h14.22l1.33,12.05-1.33.36a21.85,21.85,0,0,1,8.62-10.42A24.46,24.46,0,0,1,1440,246.2q21.69,0,21.69,25.06v37.36h-15.06V271.86q0-7.11-2.77-10.42t-8.56-3.31q-7,0-11.14,4.39T1420,274.15v34.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1470,259.09V247.76h42.89v11.33Zm42.89,37V308a22.73,22.73,0,0,1-4.76,1.15,39.41,39.41,0,0,1-5,.3q-10.25,0-15.84-5.78t-5.61-16.63V232.94l15.07-5.06v58.44a13.22,13.22,0,0,0,1.32,6.45,7.43,7.43,0,0,0,3.56,3.31,12.32,12.32,0,0,0,5,1,18.35,18.35,0,0,0,3-.24A32.55,32.55,0,0,0,1512.89,296.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1545.55,309.46q-16.63,0-26.27-7.59l4.22-10.61a35.23,35.23,0,0,0,10.48,5.43,38.76,38.76,0,0,0,11.81,1.8c3.69,0,6.51-.6,8.43-1.8a5.69,5.69,0,0,0,2.9-5.07,5.33,5.33,0,0,0-2-4.39c-1.37-1.09-3.7-2-7-2.84L1538,282.11q-8.32-1.82-12.47-6.09a15,15,0,0,1-4.16-10.9,16.21,16.21,0,0,1,3.13-9.83,20.51,20.51,0,0,1,8.8-6.68,33.22,33.22,0,0,1,13.13-2.41,39.83,39.83,0,0,1,12.53,2,31.67,31.67,0,0,1,10.49,5.73l-4.34,10.36a34.5,34.5,0,0,0-9.34-5.18,28.29,28.29,0,0,0-9.46-1.69c-3.45,0-6.14.65-8.07,1.93a6.05,6.05,0,0,0-2.89,5.3,5.39,5.39,0,0,0,1.74,4.22q1.76,1.57,6.09,2.53l10.24,2.53q9,1.93,13.2,6.21t4.15,11.26a15.46,15.46,0,0,1-6.74,13.2Q1557.24,309.46,1545.55,309.46Z"
})));

function SvgAliveVisionEventsWhiteLogomarca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1570.73 309.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alive_vision_events_whiteLogomarca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliveVisionEventsWhiteLogomarca);
export default __webpack_public_path__ + "static/media/alive_vision_events_whiteLogomarca.dd1d487e.svg";
export { ForwardRef as ReactComponent };